import React, { useMemo, useState } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import { i18n } from '../../../../../../language';
import IndividualUserDialog from '../../../IndividualUserDialog';

const useStyles = makeStyles((theme) => ({
  groupBox: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'NotoSans-Medium',
    color: '#2E4469',
    gridGap: '0.5rem',
  },
  inputBox: {
    padding: '0.642rem 0.857rem',
    borderRadius: '0.714rem',
    border: '1px solid #E4E7EB',
    height: '2.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gridGap: '1rem',
    cursor: 'pointer',
    width: '35rem',
  },
  groupName: {
    fontSize: '1.142rem',
    fontWeight: 500,
    color: '#2E4469',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  editBtn: {
    fontSize: '1.142rem',
    fontWeight: 500,
    color: '#538FFF',
  },
}));

export default function SendTo({ handleChangeTemplate, sendToList, individualUserOptions, notifyBaseOnSendTo }) {
  const classes = useStyles();
  const [showIndividualUserDialog, setShowIndividualUserDialog] = useState(false);
  const individualDisplayName = useMemo(() => {
    const roomTypeDisplayName = _.map(sendToList?.roomTypeList, (item) => item?.name);
    const staffDisplayName = _.map(sendToList?.staffList, (item) => item?.staffName);

    if (roomTypeDisplayName.length !== 0 || staffDisplayName.length !== 0) {
      return [...roomTypeDisplayName, ...staffDisplayName].join(',');
    } else {
      return '';
    }
  }, [sendToList]);

  const handleConfirmIndividual = ({ selectedRoom, selectedStaff }) => {
    handleChangeTemplate('sendToList', { roomTypeList: selectedRoom, staffList: selectedStaff });
    setShowIndividualUserDialog(false);
    if (notifyBaseOnSendTo) {
      handleChangeTemplate('notifyList', { roomTypeList: selectedRoom, staffList: selectedStaff });
    }
  };

  return (
    <Box className={classes.groupBox}>
      <Box fontSize="1.142rem" fontWeight={500} width="max-content">
        {i18n.t('EHANDOVER_SEND_TO')}
      </Box>
      <Box className={classes.inputBox} onClick={() => setShowIndividualUserDialog(true)}>
        <Box className={classes.groupName}>
          {individualDisplayName ? (
            individualDisplayName
          ) : (
            <Box color="rgb(125, 134, 169)" fontSize="1rem">
              {i18n.t('NOTIFICATION_FORWARD')}
            </Box>
          )}
        </Box>
        <Box className={classes.editBtn}>{i18n.t('EHANDOVER_EDIT')}</Box>
      </Box>
      {showIndividualUserDialog && (
        <IndividualUserDialog
          open={showIndividualUserDialog}
          closePop={() => setShowIndividualUserDialog(false)}
          roomTypeList={sendToList?.roomTypeList}
          staffList={sendToList?.staffList}
          individualUsers={individualUserOptions}
          handleConfirm={handleConfirmIndividual}
        />
      )}
    </Box>
  );
}
